export default __webpack_public_path__ + "static/media/IS.e2740789.svg";